import api from "../config/api";

export const partnerApi = {
  getProfile: () => api.get("/partner/profile"),
  updateAvailability: (acceptingBookings) =>
    api.put("/partner/profile/availability", { acceptingBookings }),
  getBookings: (params) => api.get("/partner/bookings", { params }),
  getBookingById: (id) => api.get(`/partner/bookings/${id}`),

  acceptJob: (id) => api.post(`/partner/bookings/${id}/accept`),
  startService: (id) => api.post(`/partner/bookings/${id}/start`),
  updateBooking: (id, data) => api.put(`/partner/bookings/${id}`, data),
  requestCompletion: (id) =>
    api.post(`/partner/bookings/${id}/request-completion`),
  completeService: (id, otp, vehicleKm) =>
    api.post(`/partner/bookings/${id}/complete`, {
      otp,
      ...(vehicleKm != null ? { vehicleKm: parseInt(vehicleKm, 10) } : {}),
    }),
  collectPayment: (id, paymentMethod, paymentReference) =>
    api.post(`/partner/bookings/${id}/collect-payment`, {
      paymentMethod,
      paymentReference,
    }),
  generateBill: (id) => api.post(`/partner/bookings/${id}/generate-bill`),
  syncPayment: (id) => api.post(`/partner/bookings/${id}/sync-payment`),
  uploadImages: (id, formData) =>
    api.post(`/partner/bookings/${id}/images`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 150_000,
    }),
  getInvoice: (id) =>
    api.get(`/partner/bookings/${id}/invoice`, { responseType: "blob" }),

  // Inventory / Parts
  getInventory: (params) => api.get("/partner/inventory", { params }),
  addParts: (bookingId, items) =>
    api.post(`/partner/bookings/${bookingId}/parts`, { items }),
  removePart: (bookingId, partIndex) =>
    api.delete(`/partner/bookings/${bookingId}/parts/${partIndex}`),

  // Settlements (read-only)
  getSettlements: (params) => api.get("/partner/settlements", { params }),
  getSettlementDetail: (id) => api.get(`/partner/settlements/${id}`),
  getFinanceSummary: () => api.get("/partner/finance-summary"),

  // Warranty lookup — gated by the WARRANTY_LOOKUP module.
  getWarrantyLookup: (q) => api.get("/partner/warranty-lookup", { params: { q } }),
};
